import { LineItem } from "@commercetools/platform-sdk"
import { CartCalculator } from "../cart/CartCalculator"
import { useStoreContext } from "../i18n/StoreHooks"

export const useDiscount = () => {
  const { formatCurrency } = useStoreContext()

  const discountedPriceAndPriceBeforeDiscounted = (item: LineItem) => {
    if (item.price.value.centAmount !== item.totalPrice.centAmount) {
      const productPrice = formatCurrency(
        CartCalculator.lineItemOriginalTotalPrice(item)
      )
      const discountedPrice = formatCurrency(
        CartCalculator.lineItemSubTotalCentAmount(item)
      )
      return {
        productPrice,
        discountedPrice:
          discountedPrice !== productPrice ? discountedPrice : undefined
      }
    }
    return {
      productPrice: formatCurrency(
        CartCalculator.lineItemSubTotalCentAmount(item)
      ),
      discountedPrice: undefined
    }
  }

  const individualPriceAndPriceBeforeDiscounted = (item: LineItem) => {
    const productPrice = formatCurrency(
      CartCalculator.lineItemOriginalTotalPrice({ ...item, quantity: 1 })
    )
    const discountedPriceCentAmount =
      item.discountedPricePerQuantity[0]?.discountedPrice?.value.centAmount || 0
    const discountedPrice = formatCurrency({
      centAmount: discountedPriceCentAmount
    })

    return {
      productPrice,
      discountedPrice:
        discountedPriceCentAmount && discountedPrice !== productPrice
          ? discountedPrice
          : undefined
    }
  }

  return {
    discountedPriceAndPriceBeforeDiscounted,
    individualPriceAndPriceBeforeDiscounted
  }
}
